import(/* webpackMode: "eager" */ "/test/app/global-error.tsx")